/**
 * @generated SignedSource<<a0df4ddda977edb91b4c16277c99cf2b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type NoteBlockStatus = "done" | "not_done" | "wont_do";
export type ToggleBlockFieldField = "DONE" | "WONT_DO";
export type ToggleBlocksFieldInput = {
  clientMutationId?: string | null;
  field: ToggleBlockFieldField;
  fromTrayApp?: boolean | null;
  ids?: ReadonlyArray<BlockID> | null;
  value: boolean;
};
export type BlockID = {
  blockKey?: string | null;
  id?: string | null;
  noteId?: string | null;
};
export type ActionItemChangeStatusMutation$variables = {
  input: ToggleBlocksFieldInput;
};
export type ActionItemChangeStatusMutation$data = {
  readonly toggleBlocksField: {
    readonly noteBlockEdges: ReadonlyArray<{
      readonly node: {
        readonly assignments: ReadonlyArray<{
          readonly assignee: {
            readonly email: string;
            readonly fullName: string;
            readonly id: string;
            readonly image: string;
            readonly isExternal: boolean;
            readonly isGuest: boolean;
          };
          readonly status: NoteBlockStatus | null;
        }> | null;
        readonly completedBy: {
          readonly fullName: string;
          readonly id: string;
        } | null;
        readonly done: boolean;
        readonly id: string;
        readonly updatedAt: string | null;
        readonly wontDo: boolean;
      } | null;
    }>;
  } | null;
};
export type ActionItemChangeStatusMutation = {
  response: ActionItemChangeStatusMutation$data;
  variables: ActionItemChangeStatusMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "done",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "wontDo",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "completedBy",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v6/*: any*/)
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "assignee",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "image",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isGuest",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isExternal",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ActionItemChangeStatusMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ToggleBlocksFieldPayload",
        "kind": "LinkedField",
        "name": "toggleBlocksField",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteBlockEdge",
            "kind": "LinkedField",
            "name": "noteBlockEdges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NoteBlock",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NoteBlockAssignment",
                    "kind": "LinkedField",
                    "name": "assignments",
                    "plural": true,
                    "selections": [
                      (v8/*: any*/),
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ActionItemChangeStatusMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ToggleBlocksFieldPayload",
        "kind": "LinkedField",
        "name": "toggleBlocksField",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteBlockEdge",
            "kind": "LinkedField",
            "name": "noteBlockEdges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NoteBlock",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NoteBlockAssignment",
                    "kind": "LinkedField",
                    "name": "assignments",
                    "plural": true,
                    "selections": [
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fc10a87a75ffc323509cc34810deea95",
    "id": null,
    "metadata": {},
    "name": "ActionItemChangeStatusMutation",
    "operationKind": "mutation",
    "text": "mutation ActionItemChangeStatusMutation(\n  $input: ToggleBlocksFieldInput!\n) {\n  toggleBlocksField(input: $input) {\n    noteBlockEdges {\n      node {\n        id\n        done\n        wontDo\n        updatedAt\n        completedBy {\n          id\n          fullName\n        }\n        assignments {\n          status\n          assignee {\n            id\n            fullName\n            image\n            isGuest\n            isExternal\n            email\n          }\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3aef438b48e2269ff99d68e7fcb6653a";

export default node;
